import React, { useState, useRef, createRef } from 'react'
import "./clientsolarlogin.css"
import { useNavigate } from 'react-router-dom';
import { useAuthSolar } from '../../../setup/AuthContextSolar'
import appCheck from '../../../setup/Firebase';
import { authSolar} from '../../../setup/FirebaseSolar'; // Import your Firebase instance

export default function ClientSolarLogin() {
    // const checkRole = async () => {



      
    //   const tokenResult = await authSolar.currentUser.getIdTokenResult(true)
    //   const role = tokenResult.claims

    //   console.log(role)
    // }

    // checkRole()
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuthSolar()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
async function handleSubmit(e) {
  e.preventDefault();

  try {
    setError("");
    setLoading(true);

    await login(
      emailRef.current.value,
      passwordRef.current.value
    );

    navigate("/Premium-Solar-Calculator");

  } catch (e) {
    console.error(e);
    const message = "Login credentials incorrect";
    setError(message);
    alert(message);
    return; // stop here
  } finally {
    setLoading(false); // cleanup only
  }
}

  // function onChange(value) {
  //   console.log("Captcha value:", value);
  // }

  return (
    <div className='emas__clientlogin'>
      <div className='emas__clientlogin-container'>
        <h1>Solar Login</h1>
        <a href='/Create-Solar-Account'>Create an account</a>
        <form onSubmit={handleSubmit}>
          <p>Email</p>
          <input ref={emailRef} type={"email"} placeholder="enter email" required />
          <p>Password</p>
          <input ref={passwordRef} type={"password"} placeholder="enter password" required />
          <div className='emas__clientlogin-container_captcha'>
          </div>
          <button disabled={loading} type="submit">{loading ? 'Logging in...' : 'Login'}</button>
        </form>
      </div>
    </div>
  )
}


